import { loadModules, setDefaultOptions } from "esri-loader";
import { baseConfig } from "../constants/config";

// before loading the modules for the first time,
// also lazy load the CSS for the version of
// the script that you're loading from the CDN

// esri javascript api
setDefaultOptions({ css: true, version: baseConfig.esriVersion });

export default class Loader {
  constructor(loadFunc = loadModules) {
    this.loadFunc = loadFunc;
  }

  async load(modules) {
    let resolvedModules = [];
    let error = null,
      loaded = false;
    try {
      resolvedModules = await this.loadFunc(modules);
      loaded = true;
    } catch (e) {
      error = e;
    }
    return { modules: resolvedModules, loaded, error };
  }
}
